export const siteContent = {
  brand: {
    name: "Ruwan Agro",
    location: {
      en: "Repura, Muzaffarpur, Bihar 843113",
      hi: "रेपुरा, मुजफ्फरपुर, बिहार 843113",
    },
    website: "ruwanagro.com",
    logo: "/optimized/logo.webp",
  },
  contact: {
    address: {
      en: "Repura, Muzaffarpur, Bihar 843113",
      hi: "रेपुरा, मुजफ्फरपुर, बिहार 843113",
    },
    email: "ruwanagro26@gmail.com",
    phone: "+91 91554 17338",
    whatsapp: "9155417338",
    farmerSupport: ["9304777460", "9661361212"],
    website: "https://ruwanagro.com",
  },
  socials: {
    facebook: "https://www.facebook.com/mrityunjay.kumar.5439087",
  },
  teamMembers: [
    {
      id: "mritunjay-kumar",
      name: "Mritunjay Kumar",
      role: "Director",
      location: {
        en: "Repura, Muzaffarpur, Bihar 843113",
        hi: "रेपुरा, मुजफ्फरपुर, बिहार 843113",
      },
      email: "mrityunjayrepura@gmail.com",
    },
    {
      id: "sanjay-kumar",
      name: "Sanjay Kumar",
      role: "Director",
      location: {
        en: "Repura, Muzaffarpur, Bihar 843113",
        hi: "रेपुरा, मुजफ्फरपुर, बिहार 843113",
      },
      email: "skrepura@gmail.com",
    },
    {
      id: "mukund-kumar",
      name: "Mukund Kumar",
      role: "Director",
      location: {
        en: "Repura, Muzaffarpur, Bihar 843113",
        hi: "रेपुरा, मुजफ्फरपुर, बिहार 843113",
      },
      email: "mukundrepura10@gmail.com",
    },
    {
      id: "moni-devi",
      name: "Moni Devi",
      role: "Director",
      location: {
        en: "Repura, Muzaffarpur, Bihar 843113",
        hi: "रेपुरा, मुजफ्फरपुर, बिहार 843113",
      },
      email: "dmoni0128@gmail.com",
    },
    {
      id: "dhananjay-kumar",
      name: "Dhananjay Kumar",
      role: "Director",
      location: {
        en: "Repura, Muzaffarpur, Bihar 843113",
        hi: "रेपुरा, मुजफ्फरपुर, बिहार 843113",
      },
      email: "dhananjayrepura10@gmail.com",
    },
    {
      id: "suresh-thakur",
      name: "Suresh Thakur",
      role: "Director",
      location: {
        en: "Chiknauta, Marwan, Muzaffarpur, Bihar",
        hi: "चिकनौटा, मड़वन, मुजफ्फरपुर, बिहार",
      },
      email: "sureshchiknauta@gmail.com",
    },
    {
      id: "ajay-kumar-thakur",
      name: "Ajay Kumar Thakur",
      role: "Director",
      location: {
        en: "Chiknauta, Marwan, Muzaffarpur, Bihar",
        hi: "चिकनौटा, मड़वन, मुजफ्फरपुर, बिहार",
      },
      email: "ajaychiknauta@gmail.com",
    },
    {
      id: "subodh-tiwary",
      name: "Subodh Tiwary",
      role: "Director",
      location: {
        en: "Bishnudattpur, Marwan, Muzaffarpur, Bihar",
        hi: "बिश्नुदत्तपुर, मड़वन, मुजफ्फरपुर, बिहार",
      },
      email: "tiwarisubodhbishnudattpur@gmail.com",
    },
    {
      id: "prabhat-chandra",
      name: "Prabhat Chandra",
      role: "Director",
      location: {
        en: "Repura, Muzaffarpur, Bihar 843113",
        hi: "रेपुरा, मुजफ्फरपुर, बिहार 843113",
      },
      email: "prabhatrepura@gmail.com",
    },
    {
      id: "umesh-ray",
      name: "Umesh Ray",
      role: "Director",
      location: {
        en: "Chiknauta, Marwan, Muzaffarpur, Bihar",
        hi: "चिकनौटा, मड़वन, मुजफ्फरपुर, बिहार",
      },
      email: "umeshchiknauta@gmail.com",
    },
  ],
  teamPhotos: {
    "mritunjay-kumar": "/optimized/founder-primary.webp",
  },
  media: {
    hero:
      "/optimized/hero.webp",
    aboutFarmer:
      "/optimized/about-farmer.webp",
    aboutField:
      "/optimized/about-field.webp",
    productBrownRice:
      "/optimized/product-brown-rice.webp",
    productMillets:
      "/optimized/product-millets.webp",
    productSpices:
      "/optimized/product-spices.webp",
    sustainability:
      "/optimized/sustainability.webp",
    founderPrimary:
      "/optimized/founder-primary.webp",
    founderGallery: [
      "/optimized/founder-1.webp",
      "/optimized/founder-2.webp",
      "/optimized/founder-3.webp",
      "/optimized/founder-4.webp",
      "/optimized/founder-5.webp",
    ],
  },
  copy: {
    en: {
      navigation: [
        { label: "About", path: "/about" },
        { label: "Founder", path: "/founder" },
        { label: "Team", path: "/team" },
        { label: "Products", path: "/products" },
        { label: "Contact", path: "/contact" },
      ],
      headerCta: "Reach us",
      hero: {
        eyebrow: "Farmer-first agro brand",
        title: "Direct from Farmers. Naturally Grown. Honestly Delivered.",
        subtitle:
          "Ruwan Agro brings naturally grown produce, transparent sourcing, and a strong farmer network together to deliver food with trust, purity, and purpose.",
        primaryCta: "Explore our products",
        secondaryCta: "Contact us",
        highlightLabel: "Rooted in rural India",
        highlightTitle: "Trusted produce from field to family.",
        highlightText:
          "A farmer-driven brand connecting reliable produce, responsible sourcing, and modern market access.",
        impactPills: [
          "Fair prices for farmers",
          "Fresh and natural products for consumers",
          "Support for sustainable agriculture",
          "Stronger rural communities",
        ],
      },
      about: {
        eyebrow: "About brand & FPO",
        title: "A trusted bridge between farmers and families.",
        description:
          "Built on the strength of Bihar’s farming communities, Ruwan Agro is a farmer-driven initiative rooted in Repura, Muzaffarpur, Bihar 843113 and focused on sustainability, fair market access, and honestly delivered food. Established under Rupwara Marwan Fed Farmers Producer Company Limited on 21st December 2022, it supports small and marginal farmers through collective development, better opportunities, and long-term growth.",
        missionLabel: "Mission",
        mission:
          "To ensure agricultural products are cultivated responsibly, sourced ethically, and delivered with complete trust while improving livelihoods across rural communities.",
        visionLabel: "Vision",
        vision:
          "To build a sustainable agricultural ecosystem where farmers thrive, consumers trust, and nature is preserved.",
        supportingLabel: "Supporting foundation",
        supportingTitle:
          "Backed by Rupwara Marwan Fed Farmers Producer Company Limited",
        supportingDescription:
          "The farmer producer organization strengthens small and marginal farmers through collective development, market access, packaging support, financial awareness, and sustainable agriculture practices.",
      },
      founder: {
        eyebrow: "Founder leadership",
        title: "Mahant Mritunjay Das (Mritunjay Kumar)",
        subtitle:
          "A visionary leader, social reformer, and passionate advocate of farmer empowerment who turned purpose into a movement for sustainable rural growth.",
        paragraphs: [
          "Born as Mritunjay Kumar and shaped by the values of Late Awdesh Thakur, Mahant Ji rose from a humble background with determination, discipline, and a deep commitment to service.",
          "After completing his LLB degree and briefly practicing law, he chose to leave the courtroom behind and dedicate his life to agriculture, rural development, and farmer upliftment.",
          "He has worked extensively on desi cow-based farming systems, organic agriculture, and direct farmer-to-market linkages, while playing a key role in establishing Rupwara Marwan Fed Farmers Producer Company Limited in December 2022.",
          "Today, he actively supports and guides 4000+ farmers in Bihar toward organic farming, improved productivity, and stronger income opportunities while championing dignity, transparency, and long-term sustainability.",
        ],
        quote:
          "Agriculture is not just about production—it is about people, livelihoods, and long-term sustainability.",
        milestonesTitle: "Leadership highlights",
        milestones: [
          {
            id: "law-to-land",
            value: "LLB",
            label: "academic foundation followed by a purposeful shift from law to agriculture",
          },
          {
            id: "fpo-founded",
            value: "21 Dec 2022",
            label: "foundation period of Rupwara Marwan Fed Farmers Producer Company Limited",
          },
          {
            id: "farmers-guided",
            value: "4000+",
            label: "farmers guided toward organic, transparent, and income-focused farming",
          },
        ],
        focusTitle: "Focus areas",
        focusAreas: [
          "Desi cow-based farming systems",
          "Organic and sustainable agriculture",
          "Farmer reform and rural development",
          "Direct market access with fair practices",
        ],
        addressTitle: "Founder location",
        addressLines: [
          "Address: Repura, Muzaffarpur, Bihar 843113",
          "Country: India",
        ],
        galleryEyebrow: "Journey in action",
        galleryTitle: "Founder gallery",
        gallery: [
          {
            id: "recognition",
            title: "Recognition & awards",
            caption: "Representing farmer-led leadership and agri-business progress on public platforms.",
          },
          {
            id: "public-speaking",
            title: "Community leadership",
            caption: "Addressing farmers and local stakeholders on rural development and agricultural transformation.",
          },
          {
            id: "training-programme",
            title: "Training & awareness",
            caption: "Supporting field-level learning, farmer training, and climate-resilient agricultural practices.",
          },
          {
            id: "field-visit",
            title: "Field visits",
            caption: "Staying connected to ground realities and helping farmers improve productivity directly at the source.",
          },
          {
            id: "grassroots-network",
            title: "Grassroots institution building",
            caption: "Building collective platforms that strengthen farmer organization and local participation.",
          },
        ],
      },
      team: {
        eyebrow: "Our team",
        title: "A rural leadership ecosystem rooted in Muzaffarpur.",
        description:
          "Our board brings together grassroots experience, agricultural understanding, and a shared commitment to farmer empowerment, sustainable agriculture, transparent business practices, and rural economic development.",
        founderHighlightLabel: "Founder & Director",
        founderHighlightText:
          "Mahant Mritunjay Das (Mritunjay Kumar) leads the organization with a rare blend of legal understanding, rural commitment, and farmer-first vision—making him both the founder face of the movement and an active member of the board.",
        values: [
          "Farmer empowerment",
          "Sustainable agriculture",
          "Transparent business practices",
          "Rural economic development",
        ],
        roleLabel: "Role",
        locationLabel: "Location",
        emailLabel: "Email",
        memberRole: "Director",
      },
      productsSection: {
        eyebrow: "Products overview",
        title: "Purity in every category.",
        description:
          "From wholesome brown rice and nutritious millets to natural spices and everyday kitchen blends, our product range reflects careful sourcing and practical value for modern homes.",
      },
      products: [
        {
          id: "grains-cereals",
          title: "Brown Rice & Whole Grains",
          description:
            "Naturally nourishing staples designed for everyday cooking, with rich fiber, wholesome grain integrity, and clean farm-led sourcing.",
        },
        {
          id: "natural-agro-products",
          title: "Nutritious Millets",
          description:
            "Pearl millet, finger millet, little millet, foxtail millet, and millet-based mixes that support healthier living and modern nutrition needs.",
        },
        {
          id: "value-added-products",
          title: "Spices & Masalas",
          description:
            "Turmeric, red chilli, coriander, cumin, garam masala, and kitchen blends packed for pure taste, aroma, and everyday convenience.",
        },
      ],
      impactSection: {
        eyebrow: "Farmer network impact",
        title: "Growing value across the agricultural chain.",
        description:
          "Every purchase supports better market access, stronger rural livelihoods, and a more sustainable food system.",
        marquee:
          "EMPOWERING BIHAR FARMERS • NATURALLY GROWN • HONESTLY DELIVERED • DIRECT FROM SOURCE • ",
        stats: [
          {
            id: "farmers-network",
            value: "5000+",
            label: "farmers in the growing network",
          },
          {
            id: "location-reach",
            value: "01",
            label: "rooted base in Muzaffarpur, Bihar",
          },
          {
            id: "value-chain",
            value: "360°",
            label: "support across sourcing, quality, packaging, and delivery",
          },
        ],
      },
      valuesSection: {
        eyebrow: "Sustainability & trust",
        title: "Why customers and farming communities choose us.",
        description:
          "We bring together responsible farming, transparent operations, and dependable quality so that producers and buyers both benefit.",
        values: [
          {
            id: "direct-sourcing",
            title: "Direct from farmers",
            description:
              "We reduce unnecessary intermediaries so producers gain fairer prices and families receive fresher products.",
          },
          {
            id: "natural-farming",
            title: "Naturally grown",
            description:
              "Our ecosystem encourages eco-friendly practices that protect soil health, reduce chemical dependency, and support future generations.",
          },
          {
            id: "quality-assurance",
            title: "Quality assured",
            description:
              "From farm-level monitoring to organized procurement and hygienic packaging, quality is built into every step.",
          },
          {
            id: "transparent-trust",
            title: "Transparent practices",
            description:
              "We believe in honest product representation, clear communication, and an agricultural model people can trust.",
          },
        ],
        coreValuesLabel: "Core values",
        coreValues: ["Integrity", "Commitment", "Sustainability", "Collaboration"],
      },
      contactSection: {
        eyebrow: "Contact & partnerships",
        title: "Let’s grow something meaningful together.",
        description:
          "Reach out for product inquiries, distribution opportunities, sourcing partnerships, or farmer network collaboration.",
        labels: {
          address: "Visit us",
          phone: "Call us",
          email: "Email us",
          website: "Website",
        },
        farmerSupportLabel: "Farmer support lines",
      },
      contactForm: {
        eyebrow: "Start a conversation",
        title: "Tell us what you need.",
        placeholders: {
          name: "Your name",
          email: "Your email",
          phone: "Phone number",
          message: "Share your requirement, inquiry, or partnership idea",
        },
        note:
          "Prefer a direct reply? Leave your phone number and we’ll get back to you.",
        submit: "Send inquiry",
        sending: "Sending...",
        successToast:
          "Thanks for reaching out. Our team will contact you soon.",
        errorToast:
          "We couldn’t send your message right now. Please try again.",
        directTitle: "Connect with us directly.",
        directDescription:
          "For faster communication, reach us directly on WhatsApp or email and our team will respond quickly.",
        whatsappLabel: "WhatsApp us",
        emailLabel: "Email us",
      },
      footer: {
        tagline: "Choose better. Support farmers. Live healthier.",
        supportingText:
          "Backed by Rupwara Marwan Fed Farmers Producer Company Limited",
        linksTitle: "Quick links",
        contactTitle: "Contact & social",
        facebookLabel: "Facebook",
        bottomLine: "Direct from farmers. Naturally grown. Honestly delivered.",
        copyrightLine: "All rights reserved.",
      },
    },
    hi: {
      navigation: [
        { label: "परिचय", path: "/about" },
        { label: "संस्थापक", path: "/founder" },
        { label: "टीम", path: "/team" },
        { label: "उत्पाद", path: "/products" },
        { label: "संपर्क", path: "/contact" },
      ],
      headerCta: "संपर्क करें",
      hero: {
        eyebrow: "किसान-प्रथम एग्रो ब्रांड",
        title: "किसानों से सीधे। प्राकृतिक रूप से उगाया गया। ईमानदारी से पहुँचाया गया।",
        subtitle:
          "Ruwan Agro किसानों की उपज, पारदर्शी सोर्सिंग और मजबूत किसान नेटवर्क को साथ लाकर भरोसेमंद, शुद्ध और उद्देश्यपूर्ण खाद्य उत्पाद पहुँचाता है।",
        primaryCta: "हमारे उत्पाद देखें",
        secondaryCta: "संपर्क करें",
        highlightLabel: "ग्रामीण भारत से जुड़ा",
        highlightTitle: "खेत से परिवार तक भरोसेमंद उत्पाद।",
        highlightText:
          "यह एक किसान-चालित ब्रांड है जो विश्वसनीय उत्पाद, जिम्मेदार सोर्सिंग और आधुनिक बाजार पहुँच को जोड़ता है।",
        impactPills: [
          "किसानों को उचित मूल्य",
          "ग्राहकों के लिए ताज़ा और प्राकृतिक उत्पाद",
          "टिकाऊ कृषि का समर्थन",
          "मजबूत ग्रामीण समुदाय",
        ],
      },
      about: {
        eyebrow: "ब्रांड और एफपीओ के बारे में",
        title: "किसानों और परिवारों के बीच एक भरोसेमंद सेतु।",
        description:
          "बिहार के किसान समुदायों की ताकत पर आधारित, Ruwan Agro रेपुरा, मुजफ्फरपुर, बिहार 843113 में जड़ें रखने वाली किसान-चालित पहल है, जो टिकाऊ कृषि, बेहतर बाजार पहुँच और ईमानदारी से पहुँचाए गए उत्पादों पर केंद्रित है। 21 दिसंबर 2022 को रूपवाड़ा मड़वन फेड फार्मर्स प्रोड्यूसर कंपनी लिमिटेड के अंतर्गत स्थापित यह पहल छोटे और सीमांत किसानों को सामूहिक विकास, बेहतर अवसरों और दीर्घकालिक प्रगति से सशक्त बनाती है।",
        missionLabel: "मिशन",
        mission:
          "कृषि उत्पादों को जिम्मेदारी से उगाना, नैतिक रूप से सोर्स करना और पूर्ण विश्वास के साथ पहुँचाना, साथ ही ग्रामीण समुदायों की आजीविका को बेहतर बनाना।",
        visionLabel: "विज़न",
        vision:
          "ऐसा टिकाऊ कृषि पारिस्थितिकी तंत्र बनाना जहाँ किसान समृद्ध हों, उपभोक्ता भरोसा करें और प्रकृति सुरक्षित रहे।",
        supportingLabel: "सहयोगी आधार",
        supportingTitle:
          "रूपवाड़ा मड़वन फेड फार्मर्स प्रोड्यूसर कंपनी लिमिटेड द्वारा समर्थित",
        supportingDescription:
          "यह किसान उत्पादक संगठन छोटे और सीमांत किसानों को सामूहिक विकास, बाजार पहुँच, पैकेजिंग सहायता, वित्तीय जागरूकता और टिकाऊ कृषि पद्धतियों के माध्यम से सशक्त बनाता है।",
      },
      founder: {
        eyebrow: "संस्थापक नेतृत्व",
        title: "महंत मृत्युंजय दास (मृत्युंजय कुमार)",
        subtitle:
          "एक दूरदर्शी नेता, समाज सुधारक और किसान सशक्तिकरण के समर्पित समर्थक, जिन्होंने अपने उद्देश्य को टिकाऊ ग्रामीण विकास के आंदोलन में बदला।",
        paragraphs: [
          "मृत्युंजय कुमार के रूप में जन्मे महंत जी को स्वर्गीय अवधेश ठाकुर के परिश्रम, ईमानदारी और मूल्यों ने गहराई से प्रभावित किया। विनम्र पृष्ठभूमि से आगे बढ़ते हुए उन्होंने दृढ़ निश्चय और अनुशासन के साथ अपनी पहचान बनाई।",
          "उन्होंने एलएलबी की पढ़ाई पूरी की और थोड़े समय तक वकालत भी की, लेकिन उनका वास्तविक उद्देश्य न्यायालय से आगे था। इसी कारण उन्होंने कृषि, ग्रामीण विकास और किसान उत्थान के लिए स्वयं को समर्पित कर दिया।",
          "उन्होंने देसी गाय आधारित खेती, जैविक कृषि और किसानों को सीधे बाजार से जोड़ने पर व्यापक काम किया, और दिसंबर 2022 में रुपवाड़ा मड़वन फेड फार्मर्स प्रोड्यूसर कंपनी लिमिटेड की स्थापना में महत्वपूर्ण भूमिका निभाई।",
          "आज वे बिहार में 4000+ किसानों को जैविक खेती अपनाने, उत्पादकता बढ़ाने और आय के बेहतर अवसर बनाने के लिए सक्रिय रूप से मार्गदर्शन दे रहे हैं, साथ ही सम्मान, पारदर्शिता और दीर्घकालिक स्थिरता को आगे बढ़ा रहे हैं।",
        ],
        quote:
          "कृषि केवल उत्पादन नहीं है — यह लोगों, आजीविका और दीर्घकालिक स्थिरता के बारे में है।",
        milestonesTitle: "नेतृत्व की प्रमुख झलकियाँ",
        milestones: [
          {
            id: "law-to-land",
            value: "LLB",
            label: "शैक्षणिक आधार, जिसके बाद कानून से कृषि की ओर उद्देश्यपूर्ण बदलाव",
          },
          {
            id: "fpo-founded",
            value: "21 Dec 2022",
            label: "रूपवाड़ा मड़वन फेड फार्मर्स प्रोड्यूसर कंपनी लिमिटेड की स्थापना का चरण",
          },
          {
            id: "farmers-guided",
            value: "4000+",
            label: "जैविक, पारदर्शी और आय-केंद्रित खेती की ओर मार्गदर्शित किसान",
          },
        ],
        focusTitle: "मुख्य कार्यक्षेत्र",
        focusAreas: [
          "देसी गाय आधारित खेती प्रणाली",
          "जैविक और टिकाऊ कृषि",
          "किसान सुधार और ग्रामीण विकास",
          "उचित और पारदर्शी बाजार पहुँच",
        ],
        addressTitle: "संस्थापक का पता",
        addressLines: [
          "पता: रेपुरा, मुजफ्फरपुर, बिहार 843113",
          "देश: भारत",
        ],
        galleryEyebrow: "कार्य यात्रा की झलकियाँ",
        galleryTitle: "संस्थापक गैलरी",
        gallery: [
          {
            id: "recognition",
            title: "सम्मान और पहचान",
            caption: "किसान-नेतृत्व वाले प्रयासों और एग्री-बिजनेस प्रगति का सार्वजनिक मंचों पर प्रतिनिधित्व।",
          },
          {
            id: "public-speaking",
            title: "सामुदायिक नेतृत्व",
            caption: "ग्रामीण विकास और कृषि परिवर्तन पर किसानों और स्थानीय हितधारकों को संबोधित करते हुए।",
          },
          {
            id: "training-programme",
            title: "प्रशिक्षण और जागरूकता",
            caption: "क्षेत्रीय प्रशिक्षण, किसान जागरूकता और जलवायु-अनुकूल कृषि पद्धतियों को समर्थन देते हुए।",
          },
          {
            id: "field-visit",
            title: "मैदानी दौरे",
            caption: "जमीन से जुड़े रहकर किसानों को सीधे खेत स्तर पर बेहतर उत्पादकता के लिए मार्गदर्शन।",
          },
          {
            id: "grassroots-network",
            title: "जमीनी संगठन निर्माण",
            caption: "ऐसे सामूहिक मंचों का निर्माण जो किसानों के संगठन और स्थानीय भागीदारी को मजबूत बनाते हैं।",
          },
        ],
      },
      team: {
        eyebrow: "हमारी टीम",
        title: "मुजफ्फरपुर में जड़ों वाला ग्रामीण नेतृत्व तंत्र।",
        description:
          "हमारा बोर्ड जमीनी अनुभव, कृषि की गहरी समझ और किसान सशक्तिकरण, टिकाऊ कृषि, पारदर्शी व्यावसायिक प्रक्रियाओं और ग्रामीण आर्थिक विकास के साझा संकल्प को साथ लाता है।",
        founderHighlightLabel: "संस्थापक एवं निदेशक",
        founderHighlightText:
          "महंत मृत्युंजय दास (मृत्युंजय कुमार) संगठन का नेतृत्व कानूनी समझ, ग्रामीण प्रतिबद्धता और किसान-प्रथम दृष्टि के साथ करते हैं—वे इस आंदोलन का चेहरा भी हैं और बोर्ड के सक्रिय सदस्य भी।",
        values: [
          "किसान सशक्तिकरण",
          "टिकाऊ कृषि",
          "पारदर्शी व्यवसाय",
          "ग्रामीण आर्थिक विकास",
        ],
        roleLabel: "भूमिका",
        locationLabel: "स्थान",
        emailLabel: "ईमेल",
        memberRole: "निदेशक",
      },
      productsSection: {
        eyebrow: "उत्पाद परिचय",
        title: "हर श्रेणी में शुद्धता।",
        description:
          "पौष्टिक ब्राउन राइस, हेल्दी मिलेट्स, प्राकृतिक मसाले और रोज़मर्रा के किचन ब्लेंड्स—हमारी उत्पाद श्रृंखला सावधानीपूर्वक सोर्सिंग और उपयोगी गुणवत्ता को दर्शाती है।",
      },
      products: [
        {
          id: "grains-cereals",
          title: "ब्राउन राइस और होल ग्रेन्स",
          description:
            "दैनिक उपयोग के लिए पौष्टिक, फाइबर-समृद्ध और स्वाभाविक रूप से बेहतर अनाज, जो साफ-सुथरी किसान-आधारित सोर्सिंग से आते हैं।",
        },
        {
          id: "natural-agro-products",
          title: "पौष्टिक मिलेट्स",
          description:
            "बाजरा, रागी, कुटकी, कंगनी और मिलेट-आधारित मिक्स—जो आधुनिक पोषण और हेल्दी जीवनशैली के लिए उपयुक्त हैं।",
        },
        {
          id: "value-added-products",
          title: "मसाले और मसाला मिश्रण",
          description:
            "हल्दी, लाल मिर्च, धनिया, जीरा, गरम मसाला और किचन ब्लेंड्स—जो शुद्ध स्वाद, सुगंध और आसान उपयोग के लिए पैक किए गए हैं।",
        },
      ],
      impactSection: {
        eyebrow: "किसान नेटवर्क का प्रभाव",
        title: "कृषि श्रृंखला के हर चरण में मूल्य वृद्धि।",
        description:
          "हर खरीद बेहतर बाजार पहुँच, मजबूत ग्रामीण आजीविका और अधिक टिकाऊ खाद्य व्यवस्था को समर्थन देती है।",
        marquee:
          "बिहार के किसानों को सशक्त बनाते हुए • प्राकृतिक रूप से उगाया गया • ईमानदारी से पहुँचाया गया • सीधे स्रोत से • ",
        stats: [
          {
            id: "farmers-network",
            value: "5000+",
            label: "किसानों का बढ़ता नेटवर्क",
          },
          {
            id: "location-reach",
            value: "01",
            label: "मुजफ्फरपुर, बिहार में मजबूत आधार",
          },
          {
            id: "value-chain",
            value: "360°",
            label: "सोर्सिंग, गुणवत्ता, पैकेजिंग और डिलीवरी तक सहयोग",
          },
        ],
      },
      valuesSection: {
        eyebrow: "सततता और भरोसा",
        title: "ग्राहक और किसान समुदाय हमें क्यों चुनते हैं।",
        description:
          "हम जिम्मेदार खेती, पारदर्शी संचालन और भरोसेमंद गुणवत्ता को साथ लाते हैं, ताकि उत्पादक और खरीदार दोनों लाभान्वित हों।",
        values: [
          {
            id: "direct-sourcing",
            title: "किसानों से सीधे",
            description:
              "हम अनावश्यक बिचौलियों को कम करते हैं ताकि किसानों को बेहतर मूल्य मिले और परिवारों को ताज़े उत्पाद प्राप्त हों।",
          },
          {
            id: "natural-farming",
            title: "प्राकृतिक खेती",
            description:
              "हमारा तंत्र पर्यावरण-अनुकूल खेती को बढ़ावा देता है, जो मिट्टी की सेहत, कम रसायन उपयोग और आने वाली पीढ़ियों की सुरक्षा में मदद करता है।",
          },
          {
            id: "quality-assurance",
            title: "गुणवत्ता की गारंटी",
            description:
              "फार्म-स्तर निगरानी से लेकर सुव्यवस्थित खरीद और स्वच्छ पैकेजिंग तक, हर चरण में गुणवत्ता सुनिश्चित की जाती है।",
          },
          {
            id: "transparent-trust",
            title: "पारदर्शी प्रक्रियाएँ",
            description:
              "हम ईमानदार उत्पाद प्रस्तुति, स्पष्ट संवाद और भरोसेमंद कृषि मॉडल में विश्वास करते हैं।",
          },
        ],
        coreValuesLabel: "मुख्य मूल्य",
        coreValues: ["ईमानदारी", "प्रतिबद्धता", "सततता", "सहयोग"],
      },
      contactSection: {
        eyebrow: "संपर्क और साझेदारी",
        title: "आइए, साथ मिलकर कुछ सार्थक बढ़ाएँ।",
        description:
          "उत्पाद संबंधी जानकारी, वितरण अवसरों, सोर्सिंग साझेदारी या किसान नेटवर्क सहयोग के लिए हमसे संपर्क करें।",
        labels: {
          address: "हमसे मिलें",
          phone: "कॉल करें",
          email: "ईमेल करें",
          website: "वेबसाइट",
        },
        farmerSupportLabel: "किसान सहायता नंबर",
      },
      contactForm: {
        eyebrow: "बातचीत शुरू करें",
        title: "अपनी आवश्यकता हमें बताइए।",
        placeholders: {
          name: "आपका नाम",
          email: "आपका ईमेल",
          phone: "फोन नंबर",
          message: "अपनी आवश्यकता, पूछताछ या साझेदारी का विचार लिखें",
        },
        note:
          "यदि आप सीधे जवाब चाहते हैं, तो अपना फोन नंबर छोड़ें और हम आपसे संपर्क करेंगे।",
        submit: "पूछताछ भेजें",
        sending: "भेजा जा रहा है...",
        successToast:
          "संपर्क करने के लिए धन्यवाद। हमारी टीम जल्द ही आपसे संपर्क करेगी।",
        errorToast:
          "अभी आपका संदेश नहीं भेजा जा सका। कृपया फिर से प्रयास करें।",
        directTitle: "सीधे हमसे जुड़ें।",
        directDescription:
          "तेज़ संवाद के लिए आप सीधे WhatsApp या ईमेल के माध्यम से हमसे संपर्क कर सकते हैं। हमारी टीम शीघ्र उत्तर देगी।",
        whatsappLabel: "व्हाट्सऐप करें",
        emailLabel: "ईमेल करें",
      },
      footer: {
        tagline: "बेहतर चुनें। किसानों का साथ दें। स्वस्थ जीवन अपनाएँ।",
        supportingText:
          "रूपवाड़ा मड़वन फेड फार्मर्स प्रोड्यूसर कंपनी लिमिटेड द्वारा समर्थित",
        linksTitle: "त्वरित लिंक",
        contactTitle: "संपर्क और सोशल",
        facebookLabel: "फेसबुक",
        bottomLine: "किसानों से सीधे। प्राकृतिक रूप से उगाया गया। ईमानदारी से पहुँचाया गया।",
        copyrightLine: "सर्वाधिकार सुरक्षित।",
      },
    },
  },
};